import React, { useState } from "react";
import { Button, Flex, Td, Tooltip, Tr, useDisclosure } from "@chakra-ui/react";
import { FaCalendar, FaExclamation, FaPlus } from "react-icons/fa";
import Mark from "./Mark";
import AddMarkModal from "./AddMarkModal";
import RemarksModal from "./RemarksModal";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";

export default function Line({ person, platoon, i, fetchMarksData, peoples }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isRemarksOpen,
    onOpen: onRemarksOpen,
    onClose: onRemarksClose,
  } = useDisclosure();
  const [hoveredLine, setHoveredLine] = useState(false);

  const handleSave = async (newMark) => {
    try {
      console.log("test", person);

      const response = await axios.post(
        apiUrl + "/data/school/company/marks/add",
        {
          userID: person.userDBID,
          mark: newMark.mark,
          comment: newMark.comment,
          color: newMark.color,
        },
        {
          headers: { "x-access-token": localStorage.getItem("token") },
        }
      );
      fetchMarksData();
    } catch (error) {
      console.error("Błąd podczas zapisywania oceny:", error);
    }
  };

  function getColor(platoon) {
    if (platoon === "platoon1") {
      return "blue.500";
    } else if (platoon === "platoon2") {
      return "red.500";
    } else if (platoon === "platoon3") {
      return "green.500";
    }
  }

  return (
    <>
      <Tr
        // bgColor={i % 2 === 0 ? "blackAlpha.100" : undefined}
        onMouseEnter={() => setHoveredLine(true)}
        onMouseLeave={() => setHoveredLine(false)}
      >
        <Td
          color={person.archived ? "gray.300" : getColor(platoon)}
          fontWeight={"bold"}
          opacity={person.archived ? 0.5 : 1}
        >
          {platoon.replace("platoon", "")}
        </Td>
        <Td
          color={person.archived ? "gray.300" : getColor(platoon)}
          fontWeight={"bold"}
          opacity={person.archived ? 0.5 : 1}
        >
          {person.number}
        </Td>
        <Td
          color={person.archived ? "gray.300" : getColor(platoon)}
          fontWeight={"bold"}
          opacity={person.archived ? 0.5 : 1}
        >
          <Tooltip label={`Login: ${person.login}`} hasArrow placement="top">
            {person.nick}
          </Tooltip>
        </Td>
        <Td>
          <Flex gap="1" alignItems="center">
            {person.marks.map((mark, i) => (
              <Mark
                key={i}
                markId={mark.id}
                mark={mark.mark}
                color={mark.color}
                comment={mark.comment}
                addedBy={mark.addedBy}
                fetchMarksData={fetchMarksData}
                disabled={person.archived}
              />
            ))}
            {!localStorage.getItem("roles").includes("1150112550336335982") && (
            <Button
              size="xs"
              colorScheme="green"
              ml="3"
              visibility={hoveredLine ? "visible" : "hidden"}
              onClick={onOpen}
              disabled={person.archived}
            >
              <FaPlus />
            </Button>
            )}
          </Flex>
        </Td>
        <Td>
          <Flex gap="1">
            <Mark
              mark={person.remarks.positive || 0}
              color="2"
              disabled={person.archived}
            />
            <Mark
              mark={person.remarks.negative || 0}
              color="red.500"
              disabled={person.archived}
            />
          </Flex>
        </Td>
        <Td>
          <Flex gap="1">
            <Mark
              mark={person.attendance.OB || 0}
              color="5"
              disabled={person.archived}
            />
            <Mark
              mark={person.attendance.NB || 0}
              color="red.500"
              disabled={person.archived}
            />
            <Mark
              mark={person.attendance.U || 0}
              color="4"
              disabled={person.archived}
            />
          </Flex>
        </Td>
        <Td>
          {/* <Tooltip label="Wyświetl frekwencję" hasArrow placement="top">
            <Button size="xs" colorScheme="orange">
              <FaCalendar />
            </Button>
          </Tooltip> */}
          {!localStorage.getItem("roles").includes("1150112550336335982") && (
          <Tooltip label="Wyświetl uwagi" hasArrow placement="top">
            <Button
              size="xs"
              colorScheme="red"
              ml="2"
              onClick={onRemarksOpen}
              disabled={person.archived}
            >
              <FaExclamation />
            </Button>
          </Tooltip>
          )}
        </Td>
      </Tr>
      <AddMarkModal isOpen={isOpen} onClose={onClose} onSave={handleSave} />
      <RemarksModal
        isOpen={isRemarksOpen}
        onClose={onRemarksClose}
        userId={person.userDBID}
        fetchMarksData={fetchMarksData}
        peoples={peoples}
      />
    </>
  );
}
